import { c as _c } from "react/compiler-runtime";
interface ITableRendererProps {
  value: {
    rows: {
      cells: string[];
    }[];
  };
}
const TableRenderer = t0 => {
  const $ = _c(11);
  const {
    value
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== value?.rows) {
    t4 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const rows = value?.rows || [];
      if (!rows.length) {
        t4 = null;
        break bb0;
      }
      t2 = "my-6 w-full border-collapse border border-gray-300";
      t3 = <thead><tr>{rows[0]?.cells?.map(_temp)}</tr></thead>;
      t1 = rows.slice(1).map(_temp3);
    }
    $[0] = value?.rows;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  if (t4 !== Symbol.for("react.early_return_sentinel")) {
    return t4;
  }
  let t5;
  if ($[5] !== t1) {
    t5 = <tbody>{t1}</tbody>;
    $[5] = t1;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t2 || $[8] !== t3 || $[9] !== t5) {
    t6 = <table className={t2}>{t3}{t5}</table>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
export default TableRenderer;
function _temp(cell, i) {
  return <th key={i} className="border border-gray-300 bg-gray-100 p-3 text-left font-semibold text-[#0074a6]">{cell}</th>;
}
function _temp2(cell_0, cellIndex) {
  return <td key={cellIndex} className="border border-gray-300 p-3 align-top text-[16px] text-[#373a36]" dangerouslySetInnerHTML={{
    __html: cell_0
  }} />;
}
function _temp3(row, rowIndex) {
  return <tr key={rowIndex}>{row?.cells?.map(_temp2)}</tr>;
}